import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { DocumentType } from '@synergy/models';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../api';
import { AppState } from '../../store/models/app-state';
import { TransitionActivity } from '../models/transition-activity';

export const TRANSITION_ACTIVITIES_RECEIVED = 'TRANSITION_ACTIVITIES_RECEIVED';
export const TRANSITION_ACTIVITIES_RESET = 'TRANSITION_ACTIVITIES_RESET';

export const transitionActivitiesReceived = (
    transitionActivities: TransitionActivity[],
    transitionsFromCount: number,
    sourceDocumentType: DocumentType,
    sourceDocumentId: number
) => {
    return {
        type: TRANSITION_ACTIVITIES_RECEIVED,
        transitionActivities,
        transitionsFromCount,
        sourceDocumentType,
        sourceDocumentId,
    };
};

export const resetTransitions = () => {
    return {
        type: TRANSITION_ACTIVITIES_RESET,
    };
};

export const fetchTransitions = (documentType: DocumentType, documentId: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.transitionActivities.getTransitionsActivities(documentType, documentId);
        if (response.success) {
            const transitionsFromCount = response.result?.meta?.transitionsFromCount || 0;

            dispatch(
                transitionActivitiesReceived(response.result.items, transitionsFromCount, documentType, documentId)
            );
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
